import React from 'react'
import { Headings } from '../../components';
import { data } from '../../constants';
import './CaseStudies.css';
import { FiArrowUpRight } from 'react-icons/fi'

const CaseStudies = () => {
  return (
    <section className="use-cases section-padding" id="use-cases">
      <div className="site-container">
        <Headings title="Enterprise AI use cases" text="Practical areas where SmartSastram applies Dataface.ai and AI engineering patterns for enterprise teams." />

        <div className="case-studies">
          {data.CaseStudies.map(({ title, text, link, label }, index) => (
            <article key={index} className="case-studies-item">
              <span>{`0${index + 1}`}</span>
              <h3>{title}</h3>
              <p>{text}</p>
              <a href={link}>{label} <FiArrowUpRight /></a>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CaseStudies
